import React from 'react'

const PurchaseHistory = () => {
  return (
    <div className='bg-richblack-900 text-white' >
      <h2 className='text-3xl font-medium text-richblack-5 mb-14' >Purchase History</h2>
      <p className='font-semibold text-richblack-400 border-b border-richblack-400 pb-2' >
        No transactions found
      </p>
      {/* TODO - think about it and write purchase history */}
    </div>
  )
}

export default PurchaseHistory
